export default __webpack_public_path__ + "static/media/Q32021.954a658c.PDF";